(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["essl-installer-tools"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('essl-installer-tools')) {
    const power = { af:{source:15.4,device:12.95,label:'802.3af'}, at:{source:30,device:25.5,label:'802.3at'}, bt3:{source:60,device:51,label:'802.3bt Type 3'}, bt4:{source:90,device:71.3,label:'802.3bt Type 4'} };
    const maths = {
      dc(v,a,length,size,temp,limit) {
        if (![v,a,length,size,temp,limit].every(Number.isFinite) || v<=0 || a<=0 || length<0 || size<=0 || temp<0 || temp>100 || limit<=0) return null;
        const resistance=2*length*0.0175*(1+0.00393*(temp-20))/size;
        const drop=a*resistance, end=v-drop, percent=100*drop/v;
        return {drop,end,percent,level:end<=0?'bad':percent>limit?'warn':'ok'};
      },
      poe(groups) {
        let ports=0,reserved=0,peak=0,invalid=false;
        for (const g of groups) {
          if (!power[g.type] || !Number.isInteger(g.qty) || g.qty<1 || !Number.isFinite(g.draw) || g.draw<=0) return null;
          ports+=g.qty; reserved+=g.qty*power[g.type].source;
          peak=Math.max(peak,power[g.type].source);
          if (g.draw>power[g.type].device) invalid=true;
        }
        return {ports,reserved,budget:reserved*1.2,peak,invalid};
      },
      cable(fixed,patch) {
        if (![fixed,patch].every(Number.isFinite) || fixed<0 || patch<0) return null;
        const total=fixed+patch;
        return {total,level:total>100?'bad':total>90||fixed>90?'warn':'ok',fixedWarning:fixed>90};
      },
      ups(load,rating,voltage,ah,usable,efficiency,target) {
        if (![load,rating,voltage,ah,usable,efficiency,target].every(Number.isFinite) || load<=0 || rating<=0 || voltage<=0 || ah<=0 || usable<=0 || usable>100 || efficiency<=0 || efficiency>100 || target<=0) return null;
        const energy=voltage*ah, factor=(usable/100)*(efficiency/100);
        return {energy,runtime:energy*factor/load*60,needed:load*target/60/factor,level:load>rating?'bad':load>.8*rating?'warn':'ok'};
      },
      solar(cctv,cctvPeak,standby,other,motor,cycles,seconds,voltage,days,recovery,dod,batteryEff,sun,yieldFactor,weather,start) {
        const values=[cctv,cctvPeak,standby,other,motor,cycles,seconds,voltage,days,recovery,dod,batteryEff,sun,yieldFactor,weather,start];
        if(!values.every(Number.isFinite) || [cctv,cctvPeak,standby,other,motor,cycles,seconds].some(x=>x<0) ||
          cctv+standby+other+motor<=0 || !Number.isInteger(cycles) || voltage<=0 || days<=0 || recovery<1 || recovery>30 ||
          dod<=0 || dod>100 || batteryEff<=0 || batteryEff>100 || sun<=0 || sun>12 ||
          yieldFactor<=0 || yieldFactor>100 || weather<0 || weather>90 || start<1 || (motor>0 && (cycles<=0 || seconds<=0)))return null;
        const continuous=cctv+standby+other;
        const daily=continuous*24+motor*cycles*seconds/3600;
        const nominalBattery=daily*days/(dod/100)/(batteryEff/100);
        const delivered=daily/(batteryEff/100);
        const solarFactor=sun*(yieldFactor/100)*(1-weather/100);
        const dailyArray=delivered/solarFactor;
        const recoveryEnergy=delivered*days/recovery;
        const array=(delivered+recoveryEnergy)/solarFactor;
        const peak=Math.max(cctv,cctvPeak)+standby+other+motor*start;
        return {daily,array,dailyArray,batteryAh:nominalBattery/voltage,batteryWh:nominalBattery,
          usableWh:nominalBattery*dod/100,running:Math.max(cctv,cctvPeak)+standby+other+motor,
          peak,idealCurrent:peak/voltage};
      },
      dori(mode,sensor,focal,hfov,pixels,ground,cameraHeight,targetHeight) {
        if (![pixels,ground,cameraHeight,targetHeight].every(Number.isFinite) || !Number.isInteger(pixels) || pixels<1 || ground<0 || cameraHeight<0 || targetHeight<0) return null;
        const slant=Math.hypot(ground,cameraHeight-targetHeight);
        if(slant<=0)return null;
        let halfTangent,angle;
        if(mode==='hfov') {
          if(!Number.isFinite(hfov)||hfov<=0||hfov>=180)return null;
          angle=hfov;halfTangent=Math.tan(hfov*Math.PI/360);
        } else if(mode==='lens') {
          if(!Number.isFinite(sensor)||!Number.isFinite(focal)||sensor<=0||focal<=0)return null;
          halfTangent=sensor/(2*focal);angle=2*Math.atan(halfTangent)*180/Math.PI;
        } else return null;
        const width=2*slant*halfTangent;
        const density=pixels/width;
        return {width,density,angle,slant,detect:pixels/(2*halfTangent*25),observe:pixels/(2*halfTangent*62.5),recognise:pixels/(2*halfTangent*125),identify:pixels/(2*halfTangent*250)};
      }
    };
    class EsslInstallerTools extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready=true;
        this.querySelector('[data-poe-add]').addEventListener('click',()=>this.addPoe());
        this.addEventListener('click',e=>{const b=e.target.closest('[data-poe-remove]');if(b){const rows=this.querySelectorAll('[data-poe-row]');if(rows.length>1){b.closest('[data-poe-row]').remove();this.calculate();}}});
        this.addEventListener('input',()=>this.calculate());
        this.addEventListener('change',()=>this.calculate());
        this.addEventListener('click',e=>{const button=e.target.closest('[data-essl-print]');if(button)this.printReport(button);});
        this.addEventListener('click',e=>{const button=e.target.closest('[data-essl-quote]');if(button)this.quote(button);});
        if(!document.documentElement.dataset.esslHddPrintReady){
          document.documentElement.dataset.esslHddPrintReady='true';
          document.addEventListener('click',e=>{const button=e.target.closest('[data-essl-hdd-print]');if(button){const tools=document.querySelector('essl-installer-tools');if(tools)tools.printReport(button);}});
        }
        if(!document.documentElement.dataset.esslHddQuoteReady){
          document.documentElement.dataset.esslHddQuoteReady='true';
          document.addEventListener('click',e=>{const button=e.target.closest('[data-essl-quote]');if(button.closest('essl-installer-tools'))return;const tools=document.querySelector('essl-installer-tools');if(tools)tools.quote(button);});
        }
        this.addPoe();
      }
      quote(button){
        const hdd=!button.closest('essl-installer-tools');
        const source=hdd?button.closest('details')?.querySelector('[data-project-name]')?.closest('[class*="__body"]'):button.closest('[data-tool]');
        if(!source)return;
        const title=button.closest('details')?.querySelector('summary strong')?.textContent?.trim() || 'Installer calculator';
        const project=source.querySelector('[data-project-name]')?.value.trim() || 'Not entered';
        const emailField=source.querySelector('[data-customer-email]');
        const customerEmail=emailField?.value.trim() || '';
        if(!customerEmail || !emailField.checkValidity()){
          emailField?.setCustomValidity(customerEmail?'':'Enter the customer email address for the quote.');
          emailField?.reportValidity();emailField?.focus();
          if(emailField)emailField.addEventListener('input',()=>emailField.setCustomValidity(''),{once:true});
          return;
        }
        let summary=[];
        if(hdd){
          const result=source.querySelector('[class*="__result"]');
          for(const [label,key] of [['Required usable capacity','usable'],['Incoming bandwidth','bandwidth'],['Configured usable capacity','configured'],['Reverse retention','retention']]){
            const value=result?.querySelector('[data-'+key+']')?.textContent?.trim();if(value)summary.push(label+': '+value);
          }
          summary.push('Camera groups: '+source.querySelectorAll('[data-group]').length);
        }else{
          const result=source.querySelector('.essl-tools__results');
          const label=result?.querySelector('.essl-tools__result-label')?.textContent?.trim();
          const value=result?.querySelector('.essl-tools__hero')?.textContent?.trim();
          if(label&&value)summary.push(label+': '+value);
          result?.querySelectorAll('.essl-tools__mini > span').forEach(el=>summary.push(el.textContent.trim()));
        }
        const subject='Quote request: '+title+(project==='Not entered'?'':' | '+project);
        const body=['Hello Essential Security Supplies,','', 'Please advise suitable products and pricing for this project.','', 'Calculator: '+title,'Project: '+project,'Customer email: '+customerEmail,...summary,'','Please attach the saved A4 calculator PDF before sending this message.','Please include relevant product models, availability and any information you need to confirm the specification.','', 'Planning estimates only; equipment and site details need verification.'].join('\n');
        window.location.href='mailto:sales@esssec.co.nz?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(body);
      }
      async printReport(button){
        const hdd=button.hasAttribute('data-essl-hdd-print');
        const source=hdd?[...button.closest('details').querySelectorAll('*')].find(el=>el.tagName.toLowerCase().startsWith('surveillance-storage-')):button.closest('[data-tool]');
        if(!source)return;
        const title=hdd?source.closest('details')?.querySelector('summary strong')?.textContent?.trim() || 'Surveillance HDD storage calculator':source.closest('details')?.querySelector('summary strong')?.textContent?.trim() || this.dataset.printTitle;
        const result=source.querySelector(hdd?'[class*="__result"]':'.essl-tools__results');
        if(!result)return;
        const sheet=document.createElement('div');
        sheet.className='essl-print-sheet';
        const add=(parent,tag,cls,value)=>{const el=document.createElement(tag);if(cls)el.className=cls;el.textContent=value;parent.appendChild(el);return el;};
        const head=add(sheet,'header','essl-print-sheet__head','');
        const brand=add(head,'div','','');
        let logo;
        if(this.dataset.printLogo && !this.dataset.printLogo.includes('no-image')){
          const img=document.createElement('img');img.className='essl-print-sheet__logo';img.src=this.dataset.printLogo;img.alt='Essential Security Supplies';brand.appendChild(img);
          logo=img;
        } else add(brand,'div','essl-print-sheet__brand','Essential Security Supplies');
        const contact=add(head,'div','essl-print-sheet__contact','');
        add(contact,'div','','sales@esssec.co.nz');add(contact,'div','','09 415 1500');
        add(sheet,'h1','',title);
        const project=source.querySelector('[data-project-name]')?.value.trim();
        if(project)add(sheet,'div','essl-print-sheet__project',this.dataset.printProject+': '+project);
        add(sheet,'div','essl-print-sheet__date',new Intl.DateTimeFormat('en-NZ',{dateStyle:'long'}).format(new Date()));
        const makeRows=(heading,rows,kind)=>{add(sheet,'h2','',heading);const box=add(sheet,'div','essl-print-sheet__rows'+(kind?' essl-print-sheet__rows--results':''),'');rows.forEach(([label,value])=>{const row=add(box,'div','essl-print-sheet__row','');add(row,'span','',label);add(row,'strong','',value);});};
        const fields=[...source.querySelectorAll('input,select')].filter(el=>!el.closest('template,[hidden]') && el.type!=='hidden' && !el.hasAttribute('data-project-name') && !el.hasAttribute('data-customer-email'));
        const inputs=fields.map(el=>{
          const label=el.closest('label') || el.previousElementSibling?.closest('label');
          const name=label?.textContent?.trim() || el.previousElementSibling?.textContent?.trim() || 'Value';
          const value=el.tagName==='SELECT'?el.selectedOptions[0]?.textContent?.trim():el.value;
          return [name,value || '—'];
        });
        makeRows(this.dataset.printInputs,inputs,false);
        let results=[];
        if(hdd){
          const keys=['usable','tib','bandwidth','raw','installed-required','configured','retention'];
          const labels=['Required usable capacity','Binary capacity','Incoming bandwidth','Raw required capacity','Required installed drive capacity','Configured usable capacity','Reverse retention for target drives'];
          results=keys.map((key,i)=>[labels[i],result.querySelector('[data-'+key+']')?.textContent?.trim() || '—']);
          results[0][1]+=' TB';
          const breakdown=result.querySelector('[data-breakdown]')?.textContent?.trim();
          if(breakdown)results.push(['Daily recording breakdown',breakdown]);
        }else{
          const hero=result.querySelector('.essl-tools__hero');
          results.push([result.querySelector('.essl-tools__result-label')?.textContent?.trim() || this.dataset.printResults,hero?.textContent?.trim() || '—']);
          result.querySelectorAll('.essl-tools__mini > span').forEach(el=>results.push([el.textContent.replace(el.querySelector('b')?.textContent || '','').trim(),el.querySelector('b')?.textContent?.trim() || '—']));
        }
        makeRows(this.dataset.printResults,results,true);
        const solarWarning=source.querySelector('.essl-tools__solar-warning');
        if(solarWarning)add(sheet,'p','essl-print-sheet__warning',solarWarning.textContent.trim());
        const state=result.querySelector(hdd?'[data-config-warning]':'.essl-tools__state');
        if(state?.textContent?.trim())add(sheet,'p','essl-print-sheet__note',state.textContent.trim());
        const note=hdd?this.querySelector('[data-hdd-assumption]'):result.querySelector('.essl-tools__note');
        if(note)add(sheet,'p','essl-print-sheet__note',note.textContent.trim());
        add(sheet,'footer','essl-print-sheet__foot',this.dataset.printDisclaimer);
        document.querySelectorAll('body > .essl-print-sheet').forEach(el=>el.remove());
        let printStyle=document.getElementById('essl-print-global-style');
        if(!printStyle){
          printStyle=document.createElement('style');
          printStyle.id='essl-print-global-style';
          printStyle.textContent=`.essl-print-sheet{display:none!important}
          @page{size:A4 portrait;margin:12mm}
          @media print{
            html body > :not(.essl-print-sheet){display:none!important}
            html body > .essl-print-sheet{display:flex!important;flex-direction:column;box-sizing:border-box;min-height:273mm;width:100%;background:#fff;color:#172334;font:10pt Arial,sans-serif}
            .essl-print-sheet *{box-sizing:border-box}
            .essl-print-sheet__head{display:flex;align-items:center;justify-content:space-between;gap:12mm;padding-bottom:6mm;border-bottom:2px solid #173e70}
            .essl-print-sheet__logo{max-width:65mm;max-height:23mm;object-fit:contain}
            .essl-print-sheet__brand{font-size:15pt;font-weight:700;color:#173e70}
            .essl-print-sheet__contact{text-align:right;font-size:9pt;line-height:1.6}
            .essl-print-sheet h1{margin:7mm 0 2mm;font-size:18pt;color:#173e70}
            .essl-print-sheet__project{font-size:11pt;font-weight:700;margin:1mm 0;color:#173e70}
            .essl-print-sheet__date{color:#5a6878;font-size:9pt}
            .essl-print-sheet h2{font-size:11pt;color:#173e70;margin:7mm 0 2mm}
            .essl-print-sheet__rows{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:0 8mm}
            .essl-print-sheet__row{display:flex;justify-content:space-between;gap:5mm;padding:2mm 0;border-bottom:1px solid #dde4ec;break-inside:avoid}
            .essl-print-sheet__row span{color:#45566b}
            .essl-print-sheet__row strong{text-align:right;overflow-wrap:anywhere}
            .essl-print-sheet__rows--results{grid-template-columns:1fr}
            .essl-print-sheet__rows--results .essl-print-sheet__row:first-child{font-size:13pt;color:#173e70}
            .essl-print-sheet__note{margin:5mm 0 0;color:#45566b;line-height:1.45}
            .essl-print-sheet__warning{margin:5mm 0 0;padding:3mm;border:1px solid #9a6700;color:#5b3900;font-weight:700;line-height:1.4;break-inside:avoid}
            .essl-print-sheet__foot{margin-top:auto;padding-top:5mm;border-top:1px solid #aebccc;font-size:8.5pt;line-height:1.45;color:#45566b}
          }`;
          document.head.appendChild(printStyle);
        }
        document.body.appendChild(sheet);
        if(logo)await logo.decode().catch(()=>{logo.remove();add(brand,'div','essl-print-sheet__brand','Essential Security Supplies');});
        window.print();
      }
      field(parent,key){return Number(parent.querySelector('[data-'+key+']').value);}
      put(key,value){this.querySelector('[data-'+key+']').textContent=value;}
      state(key,message,level){const el=this.querySelector('[data-'+key+'-state]');el.textContent=message;el.dataset.level=level;}
      addPoe(){
        const node=this.querySelector('[data-poe-template]').content.firstElementChild.cloneNode(true);
        this.querySelector('[data-poe-rows]').appendChild(node);
        this.calculate();
      }
      calculate(){
        const dc=maths.dc(...['dc-voltage','dc-current','dc-length','dc-size','dc-temp','dc-limit'].map(k=>this.field(this,k)));
        this.put('dc-end',dc?dc.end.toFixed(2)+' V':'—');
        this.put('dc-drop',dc?dc.drop.toFixed(2)+' V':'—');
        this.put('dc-percent',dc?dc.percent.toFixed(1)+'%':'—');
        this.state('dc',dc?this.dataset['dc'+dc.level[0].toUpperCase()+dc.level.slice(1)]:this.dataset.dcInvalid,dc?dc.level:'bad');
        const groups=[...this.querySelectorAll('[data-poe-row]')].map(row=>({qty:this.field(row,'poe-qty'),type:row.querySelector('[data-poe-type]').value,draw:this.field(row,'poe-draw')}));
        const poe=maths.poe(groups);
        this.put('poe-budget',poe?poe.budget.toFixed(0)+' W':'—');
        this.put('poe-ports',poe?String(poe.ports):'—');
        this.put('poe-reserved',poe?poe.reserved.toFixed(0)+' W':'—');
        this.put('poe-port',poe?(poe.peak===90?'90 W':poe.peak===60?'60 W':poe.peak===30?'30 W':'15.4 W'):'—');
        this.state('poe',!poe?this.dataset.poeInvalid:poe.invalid?this.dataset.poeWarning:this.dataset.poeOk,!poe||poe.invalid?'bad':'ok');
        const cable=maths.cable(this.field(this,'cable-fixed-length'),this.field(this,'cable-patch'));
        this.put('cable-total',cable?cable.total.toFixed(1)+' m':'—');
        let cableMessage=!cable?this.dataset.cableInvalid:cable.level==='bad'?this.dataset.cableOver:cable.level==='warn'?this.dataset.cableNear:this.dataset.cableOk;
        if(cable && cable.fixedWarning) cableMessage+=' '+this.dataset.cableFixed;
        const cca=this.querySelector('[data-cable-conductor]').value==='cca';
        if(cable && cca) cableMessage+=' '+this.dataset.cableCca;
        if(cable && this.querySelector('[data-cable-poe]').value==='yes') cableMessage+=' '+this.dataset.cablePoeNote;
        this.state('cable',cableMessage,cable?(cca?'bad':cable.level):'bad');
        const ups=maths.ups(...['ups-load','ups-rating','ups-voltage','ups-ah','ups-usable','ups-efficiency','ups-target'].map(k=>this.field(this,k)));
        this.put('ups-runtime',ups?ups.runtime.toFixed(0)+' min':'—');
        this.put('ups-energy',ups?ups.energy.toFixed(0)+' Wh':'—');
        this.put('ups-needed',ups?ups.needed.toFixed(0)+' Wh':'—');
        this.state('ups',!ups?this.dataset.upsInvalid:ups.level==='bad'?this.dataset.upsOver:ups.level==='warn'?this.dataset.upsHigh:this.dataset.upsOk,ups?ups.level:'bad');
        const solarInputs=['solar-cctv','solar-cctv-peak','solar-standby','solar-other','solar-motor','solar-cycles','solar-seconds','solar-voltage','solar-days','solar-recovery','solar-dod','solar-battery-eff','solar-sun','solar-yield','solar-weather','solar-start'];
        const hasSources=this.querySelector('[data-solar-location]').value.trim() && this.querySelector('[data-solar-source]').value.trim() && this.querySelector('[data-solar-spec-source]').value.trim();
        const hasAllInputs=solarInputs.every(k=>this.querySelector('[data-'+k+']').value.trim()!=='');
        const solar=hasSources&&hasAllInputs?maths.solar(...solarInputs.map(k=>this.field(this,k))):null;
        this.put('solar-array',solar?Math.ceil(solar.array)+' Wp':'—');
        this.put('solar-daily',solar?solar.daily.toFixed(0)+' Wh/day':'—');
        this.put('solar-daily-array',solar?Math.ceil(solar.dailyArray)+' Wp':'—');
        this.put('solar-battery',solar?Math.ceil(solar.batteryAh)+' Ah':'—');
        this.put('solar-energy',solar?solar.batteryWh.toFixed(0)+' Wh':'—');
        this.put('solar-usable-energy',solar?solar.usableWh.toFixed(0)+' Wh':'—');
        this.put('solar-running',solar?solar.running.toFixed(0)+' W':'—');
        this.put('solar-peak',solar?solar.peak.toFixed(0)+' W':'—');
        this.put('solar-current',solar?solar.idealCurrent.toFixed(1)+' A':'—');
        this.state('solar',solar?this.dataset.solarOk:this.dataset.solarInvalid,solar?'ok':'bad');
        this.querySelector('[data-tool="solar"] [data-essl-print]').disabled=!solar;
        const mode=this.querySelector('[data-dori-mode]').value;
        this.querySelectorAll('[data-dori-lens-field]').forEach(el=>{el.hidden=mode!=='lens';});
        this.querySelector('[data-dori-hfov-field]').hidden=mode!=='hfov';
        const dori=maths.dori(mode,...['dori-sensor','dori-focal','dori-hfov','dori-pixels','dori-distance','dori-camera-height','dori-target-height'].map(k=>this.field(this,k)));
        this.put('dori-density',dori?dori.density.toFixed(1)+' px/m':'—');
        this.put('dori-width',dori?dori.width.toFixed(2)+' m':'—');
        this.put('dori-angle',dori?dori.angle.toFixed(1)+'°':'—');
        this.put('dori-slant',dori?dori.slant.toFixed(2)+' m':'—');
        for(const key of ['detect','observe','recognise','identify']) this.put('dori-'+key+'-distance',dori?dori[key].toFixed(1)+' m':'—');
        const grade=!dori?this.dataset.doriInvalid:dori.density>=250?this.dataset.doriIdentify:dori.density>=125?this.dataset.doriRecognise:dori.density>=62.5?this.dataset.doriObserve:dori.density>=25?this.dataset.doriDetect:this.dataset.doriBelow;
        this.state('dori',grade,!dori||dori.density<25?'warn':'ok');
      }
    }
    customElements.define('essl-installer-tools',EsslInstallerTools);
  }

  } catch(e) { console.error(e); }
})();
})();
